import { SvgIcon } from "@material-ui/core";

export const ArrowUpIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M9.42498 14.0004C8.97498 14.0004 8.66248 13.7962 8.48748 13.3879C8.31248 12.9796 8.38331 12.6171 8.69998 12.3004L11.3 9.70039C11.4 9.60039 11.5083 9.52539 11.625 9.47539C11.7416 9.42539 11.8666 9.40039 12 9.40039C12.1333 9.40039 12.2583 9.42539 12.375 9.47539C12.4916 9.52539 12.6 9.60039 12.7 9.70039L15.3 12.3004C15.6166 12.6171 15.6875 12.9796 15.5125 13.3879C15.3375 13.7962 15.025 14.0004 14.575 14.0004H9.42498Z"
        fill={props.fill || "currentColor"}
      />
    </SvgIcon>
  );
};
